import API, { ensurePrefixed } from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import getFormattedValues, { formatReceived } from 'utils/formatValues';
import { padronesEnum } from 'views/Tramites/GPM/enums';
import { getGirosDeModulos } from './girosDeModulos';
import { getTiposDeGirosModulos } from './tiposDeGirosDeModulos';

export const baseURI = 'empresas/expediente-modulos-de-mercados/';
/**
 * GET ExpedienteExpedientesInformales
 * @param {Object} params
 * @returns {Promise<Array<object>>}
 */
export const getExpedientesDeModulos = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET ExpedienteComercioInformal
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getExpedienteDeModulo = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    if (process.env.REACT_APP_ENV_NAME === 'navojoa') {
      const tipos = await getTiposDeGirosModulos();
      response.data._giros_de_modulos = await getGirosDeModulos({ expediente_modulo: id });
      response.data._giros_de_modulos = response.data._giros_de_modulos
        .map((g) => `- ${tipos.find((t) => t.id === g.giro_de_modulos)?.descripcion}`).join('\n');
    }
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST ExpedienteComercioInformal
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postExpedienteDeModulo = async (values, accion = 'EXPEDIENTE_DE_MERCADOS') => {
  try {
    const formattedValues = getFormattedValues(values);
    const accionInf = ensurePrefixed('CREAR_', accion);
    const response = await API.post(baseURI, formattedValues, {
      accionInf,
      idPadron: padronesEnum.MERCADO,
      clave: formattedValues.clave,
    });
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH ExpedienteComercioInformal
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchExpedienteDeModulo = async (id, values, accion = 'EXPEDIENTE_DE_MERCADOS') => {
  try {
    const formattedValues = getFormattedValues(values, { clean: false });
    const accionInf = ensurePrefixed('EDITAR_', accion);
    const response = await API.patch(`${baseURI}${id}`, formattedValues, {
      accionInf,
      idPadron: padronesEnum.MERCADO,
      clave: formattedValues.clave,
    });
    onSuccess(response, 'Editado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};
/**
 * DELETE ExpedienteComercioInformal
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteExpedienteDeModulo = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}/`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * GET Expedientes de Comercio Informal para la caja
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */

export const getExpedienteDeModulosCaja = async (params = null) => {
  try {
    const response = await API.get('empresas/expediente-modulos-de-mercados-caja', { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};
